"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _pluggableWidget.default;
  }
});
var _pluggableWidget = _interopRequireDefault(require("./pluggable-widget"));